import { render, staticRenderFns } from "./search-select.vue?vue&type=template&id=65e8e1a8&scoped=true&"
import script from "./search-select.vue?vue&type=script&lang=js&"
export * from "./search-select.vue?vue&type=script&lang=js&"
import style0 from "./search-select.vue?vue&type=style&index=0&id=65e8e1a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e8e1a8",
  null
  
)

export default component.exports